import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "blank-template-container" }
const _hoisted_2 = { class: "blank-template-title" }
const _hoisted_3 = { class: "steps-container" }
const _hoisted_4 = { class: "step-image" }
const _hoisted_5 = { class: "step-content" }
const _hoisted_6 = { class: "step-title" }
const _hoisted_7 = { class: "step-description" }
const _hoisted_8 = { class: "action-button-container" }

import { ref, computed } from 'vue'
// 定义 props

export default /*@__PURE__*/_defineComponent({
  __name: 'BlankTemplate',
  props: {
  title: {
    type: String,
    default: '空白模板创建视频'
  },
  stepsRows: {
    type: Array,
    required: true
  }
},
  emits: ['use-blank-template'],
  setup(__props, { emit: __emit }) {

const props = __props;

// 定义 emits
const emit = __emit;

// 处理按钮点击事件
const handleUseClick = () => {
  emit('use-blank-template');
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.stepsRows, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "steps-row",
          key: rowIndex
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (step, stepIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "step-item",
              key: stepIndex
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_image, {
                  src: step.image,
                  alt: step.title,
                  previewSrcList: [step.image],
                  "preview-teleported": true
                }, null, 8, ["src", "alt", "previewSrcList"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", _hoisted_6, _toDisplayString(step.title), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(step.description), 1)
              ])
            ]))
          }), 128))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_button, {
        class: "use-button",
        onClick: handleUseClick
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("去创建")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})